// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.typing-fade-enter-active[data-v-dfd8453b],
.typing-fade-leave-active[data-v-dfd8453b] {
  transition: opacity 0.2s ease;
}
.typing-fade-enter-from[data-v-dfd8453b],
.typing-fade-leave-to[data-v-dfd8453b] {
  opacity: 0;
}
.typing-dot-sm[data-v-dfd8453b] {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #9ca3af;
  animation: typing-bounce-sm-dfd8453b 1.2s infinite ease-in-out;
}
.typing-dot-sm[data-v-dfd8453b]:nth-child(2) {
  animation-delay: 0.2s;
}
.typing-dot-sm[data-v-dfd8453b]:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes typing-bounce-sm-dfd8453b {
0%,
  60%,
  100% {
    transform: translateY(0);
    opacity: 0.4;
}
30% {
    transform: translateY(-3px);
    opacity: 1;
}
}
.floating-action-bar[data-v-dfd8453b] {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  box-shadow:
    var(--tw-ring-offset-shadow, 0 0 #0000),
    var(--tw-ring-shadow, 0 0 #0000),
    var(--tw-shadow),
    inset 0 1px 3px #fff !important;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
